import PropTypes from "prop-types";
import React, { Component } from "react";
import ChatWindow from "./ChatWindow";
import { withStyles } from "@material-ui/core/styles";
import ChatIcon from "@material-ui/icons/Chat";
import Fab from "@material-ui/core/Fab";
import launcherIcon from "./../assets/logo-no-bg.svg";
// import incomingMessageSound from "../assets/sounds/notification.mp3";
import launcherIconActive from "./../assets/close-icon.png";

const styles = theme => ({
  fab: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    zIndex: 2100
  },
  chatIsOpened: {
    zIndex: 0
  },
  fabAssistant: {
    display: "none"
  },
  assistantPageChatbot: {
    position: "unset"
  }
});

class Launcher extends Component {
  constructor() {
    super();
    this.state = {
      launcherIcon,
      isOpen: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.mute) {
      return;
    }
    const nextMessage = nextProps.messageList[nextProps.messageList.length - 1];
    const isIncoming = (nextMessage || {}).author === "them";
    const isNew = nextProps.messageList.length > this.props.messageList.length;
    // if (isIncoming && isNew) {
    //   this.playIncomingMessageSound();
    // }
  }

  // play BEEP sound when chat starts or fulfills an intent
  // playIncomingMessageSound() {
  //   var audio = new Audio(incomingMessageSound);
  //   audio.play();
  // }

  handleClick = () => {
    if (this.props.handleClick !== undefined) {
      this.props.handleClick();
    } else {
      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  };

  render() {
    const isOpen = this.props.hasOwnProperty("isOpen") ? this.props.isOpen : this.state.isOpen;
    //console.log("launcher", isOpen);
    const classList = ["sc-launcher", isOpen ? "opened" : ""];
    const { classes, testRef } = this.props;
    const fabClass = this.props.assistantPage ? classes.fabAssistant : classes.fab;
    const assistantPositioning = this.props.assistantPage ? classes.assistantPageChatbot : classes.fab;

    return (
      <div id="sc-launcher" className={assistantPositioning}>
        <MessageCount count={this.props.newMessagesCount} isOpen={isOpen} />
        <Fab
          id="open-chat-btn"
          color="primary"
          aria-label="Chat"
          onClick={this.handleClick}
          className={fabClass + " " + (isOpen ? classes.chatIsOpened : "")}
        >
          <ChatIcon />
        </Fab>
        <ChatWindow
          // assistantPositioning={assistantPositioning}
          source={this.props.source}
          testRef={testRef}
          agentProfile={this.props.agentProfile}
          messageList={this.props.messageList}
          onUserInputSubmit={this.props.onMessageWasSent}
          onFilesSelected={this.props.onFilesSelected}
          isOpen={this.props.isOpen}
          onClose={this.handleClick}
          showEmoji={this.props.showEmoji}
          bubbles={this.props.bubbles}
          isBubbleDrillDown={this.props.isBubbleDrillDown}
          bubblesTopLevel={this.props.bubblesTopLevel}
          bubblesOnMessageWasSent={this.props.bubblesOnMessageWasSent}
          bubbleDrillDown={this.props.bubbleDrillDown}
          bubbleAnswer={this.props.bubbleAnswer}
          botIsTyping={this.props.botIsTyping}
          playingState={this.props.playingState}
          userImage={this.props.userImage}
          userFullName={this.props.userFullName}
          sidebarIsOpen={this.props.sidebarIsOpen} // to determine chat drag range
          removeDialogElicit={this.props.removeDialogElicit}
          assistantPage={this.props.assistantPage}
        />
      </div>
    );
  }
}

const MessageCount = props => {
  if (props.count === 0 || props.isOpen === true) {
    return null;
  }
  return <div className={"sc-new-messages-count"}>{props.count}</div>;
};

Launcher.propTypes = {
  onMessageWasReceived: PropTypes.func,
  onMessageWasSent: PropTypes.func,
  newMessagesCount: PropTypes.number,
  isOpen: PropTypes.bool,
  handleClick: PropTypes.func,
  messageList: PropTypes.arrayOf(PropTypes.object),
  mute: PropTypes.bool,
  showEmoji: PropTypes.bool
};

Launcher.defaultProps = {
  newMessagesCount: 0,
  showEmoji: true
};

export default withStyles(styles)(Launcher);

export { Launcher };
